module.exports = __webpack_public_path__ + "static/img/inova37.7838374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/awards/inova37.jpg
// module id = RSKB
// module chunks = 0